/**
 * @generated SignedSource<<5a6e05e080fb2a637bea08c3e39ada90>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpOwners_viewer$data = {
  readonly nftBalancesByItem: ReadonlyArray<{
    readonly balance: number | null;
    readonly chainId: string | null;
    readonly ownerAddress: {
      readonly address: string | null;
      readonly " $fragmentSpreads": FragmentRefs<"NftPdpUserLink_ethereumAddress">;
    } | null;
  } | null> | null;
  readonly user?: {
    readonly ethereumWalletAddress: {
      readonly address: string | null;
    } | null;
  } | null;
  readonly " $fragmentType": "NftPdpOwners_viewer";
};
export type NftPdpOwners_viewer$key = {
  readonly " $data"?: NftPdpOwners_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpOwners_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "address",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "nftId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpOwners_viewer",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "nftId",
          "variableName": "nftId"
        }
      ],
      "concreteType": "NftItemBalance",
      "kind": "LinkedField",
      "name": "nftBalancesByItem",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "chainId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "EthereumAddressType",
          "kind": "LinkedField",
          "name": "ownerAddress",
          "plural": false,
          "selections": [
            (v0/*:: as any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NftPdpUserLink_ethereumAddress"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "balance",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EthereumAddressType",
              "kind": "LinkedField",
              "name": "ethereumWalletAddress",
              "plural": false,
              "selections": [
                (v0/*:: as any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
})();

(node as any).hash = "970aef77696ce8460fc4f625f95f66df";

export default node;
